import { render, staticRenderFns } from "./BrandHero.vue?vue&type=template&id=2cfca92c&scoped=true&"
import script from "./BrandHero.vue?vue&type=script&lang=js&"
export * from "./BrandHero.vue?vue&type=script&lang=js&"
import style0 from "./BrandHero.vue?vue&type=style&index=0&id=2cfca92c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfca92c",
  null
  
)

export default component.exports